const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export const isValidZipcode = (zipcode: string): boolean => ZIP_REGEX.test(zipcode.trim());
